import { createElement, type ReactNode } from 'react';
import type { StickyHeaderAction } from './StickyHeader';
import { PenIcon, TrashIcon } from './chromeIcons';

/**
 * Chrome 액션(수정·결재라인편집·삭제·결재이력) 공유 빌더. 일반 보고서·TBM 공유(2026-06-15).
 *
 * 모양(라벨/아이콘/variant)은 빌더가 고정하고,
 * onClick/노출 조건/disabled/색점(statusDotIcon)은 호출처가 주입한다.
 * 모바일 ⋯ collapse는 StickyHeader 정책(collapseActionsOnMobile)이 처리(2026-06-15).
 */

/** 수정 버튼. onClick은 호출처 주입(일반=편집 라우트 navigate, TBM=편집 모드 토글). */
export function buildEditAction(onClick: () => void): StickyHeaderAction {
  return {
    key: 'edit',
    label: '수정',
    icon: createElement(PenIcon, { className: 'h-4 w-4' }),
    onClick,
    variant: 'secondary',
  };
}

/** 결재라인 편집 버튼. */
export function buildApprovalLineEditAction(onClick: () => void): StickyHeaderAction {
  return {
    key: 'approval-line-edit',
    label: '결재라인',
    icon: createElement(PenIcon, { className: 'h-4 w-4' }),
    onClick,
    variant: 'secondary',
  };
}

/** 삭제 버튼. disabled/tooltip/label은 호출처 주입(일반은 삭제 대기 상태 등). */
export function buildDeleteAction(opts: {
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
  label?: string;
}): StickyHeaderAction {
  return {
    key: 'delete',
    label: opts.label ?? '삭제',
    icon: createElement(TrashIcon, { className: 'h-4 w-4' }),
    onClick: opts.onClick,
    variant: 'danger',
    disabled: opts.disabled,
    tooltip: opts.tooltip,
  };
}

/** 결재 이력 버튼(헤더 좌측). statusDotIcon(상태 색점)은 호출처가 만들어 주입. */
export function buildApprovalHistoryAction(
  onClick: () => void,
  statusDotIcon: ReactNode,
): StickyHeaderAction {
  return {
    key: 'approval-history',
    label: '결재 이력',
    icon: statusDotIcon,
    onClick,
    variant: 'secondary',
  };
}
